import { render, staticRenderFns } from "./andrescratch.vue?vue&type=template&id=1f148770"
import script from "./andrescratch.vue?vue&type=script&lang=js"
export * from "./andrescratch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports